export default __webpack_public_path__ + "static/media/resume.05fd1715.pdf";